import { render, staticRenderFns } from "./modal_inventors.vue?vue&type=template&id=6e2920db&scoped=true"
import script from "./modal_inventors.vue?vue&type=script&lang=js"
export * from "./modal_inventors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2920db",
  null
  
)

export default component.exports